/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForDataDog extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForDataDog");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForDataDog.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForDataDog>): ServiceAccountNativeDetailsForDataDog {
        let obj = Object.assign(new ServiceAccountNativeDetailsForDataDog(), model);
        ServiceAccountNativeDetailsForDataDog.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForDataDog>): ServiceAccountNativeDetailsForDataDog {
        if (!model) return null;
        return ServiceAccountNativeDetailsForDataDog.newInstance(<ServiceAccountNativeDetailsForDataDog> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForDataDog) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForDataDog.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForDataDog): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForDataDog.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
